import React from "react";
import { Link } from "react-router-dom";
import account from "../data/account";
import { hasTenantFeature, sellsThroughReps } from "../functions/tenant-features";

/*
 * Manage Data tab shell (APP_NAVIGATION_IA.md: the Data menu collapses to
 * one item; the old Manage Audiences / Manage Markets / Manage Product
 * surfaces become tabs of Manage Data). Each surface keeps its own route —
 * legacy pagination and create/upload flows are route-based — so the tabs
 * are links and the shell renders at the top of all four pages.
 */

const TABS = [["/Data/Connect", "Connect"], ["/Data", "Feeds"], ["/Audience", "Audiences"], ["/Locations", "Markets"], ["/Product", "Products"]];

// Configuration Rules (PRODUCT_CONFIG_RULES.md §5) — only for tenants with
// Product Configurations, and only for owners/admins (the rules ARE the
// tenant's parsing config; members see the read views, not the grammar).
function visibleTabs() {
  const groups = ((account.get() || {}).groups || []).map(g => String(g).toLowerCase());
  const admin = ["owner", "administrator", "root"].some(g => groups.includes(g));
  const tabs = TABS.slice();
  if (admin && hasTenantFeature("productConfigs")) tabs.push(["/Data/Rules", "Configuration Rules"]);
  // Tracking allowlist (§290) — tenant config, so owner/admin only; no
  // feature flag (every tenant tracks).
  // Territories (SALES_TERRITORY_MAPS.md §5.1): ZIP to rep uploads with validation; owner/admin on rep-and-dealer workspaces.
  if (admin && hasTenantFeature("territoryRep") && sellsThroughReps()) tabs.push(["/Data/Territories", "Territories"]);
  if (admin) tabs.push(["/Data/Tracking", "Tracking"]);
  return tabs;
}
export default function ManageDataTabs({
  active
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "mdt-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mdt-tabs"
  }, visibleTabs().map(([to, label]) => /*#__PURE__*/React.createElement(Link, {
    key: to,
    to: to,
    className: "mdt-tab" + (active === to ? " on" : "")
  }, label))));
}